const initialQuery = `
# Welcome to Flash Payments GraphQL client.
# You can send your request using CmdOrCtrl + Enter.

# Enter your graphQL query here.
`.trimStart();

export { initialQuery };
